let createProductGroupGrid;

export function setProductGroupFactory(factory) {
  createProductGroupGrid = factory;
}

export function getProductGroupFactory() {
  return createProductGroupGrid;
}
